// import { b2x } from '@b2x/react/src';
// import React from 'react';

import { Page } from './Page';

export const TestPage = () => {
  //const { handlePopups } = b2x.usePopupsApi();

  // React.useEffect(() => {
  //   handlePopups('NAVIGATION', window.location.href, ['123', '456']);
  // }, [handlePopups]);

  return <Page>popups prova</Page>;
};
